// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2uBLo","footer":"Form_footer__22R5I"};